import { render, staticRenderFns } from "./VideoSmall.vue?vue&type=template&id=b9a65550"
import script from "./VideoSmall.vue?vue&type=script&lang=js"
export * from "./VideoSmall.vue?vue&type=script&lang=js"
import style0 from "./VideoSmall.vue?vue&type=style&index=0&id=b9a65550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports